import { DataFilter } from '@siclop/kstone-vue'

export class EstimationScaleFilter extends DataFilter {
  code?: string
  label?: string
  isActive?: boolean

  constructor(data?: Partial<EstimationScaleFilter>) {
    super(data)
    if (data) {
      this.code = data.code
      this.label = data.label
      this.isActive = data.isActive
    }
  }
}
